<div class="receive-order-container">
  <div class="page-header-container">
    <div class="header-composed">
      <a routerLink="/inventory/order-history" class="text-title-2 back-ref">
        Purchase Orders
      </a>
      <div class="text-title-2 header">
        Receive Order
      </div>
    </div>

    <div class="page-subheader">
      <div class="flex flex-col">
          <div class="flex">
            <div class="inventory-details">
              <div class="label">Wholesaler:</div>
              <div class="value">
                {{receiveEDI?.wholesalerName}}
              </div>
            </div>
            <div class="inventory-details" *ngIf="receiveEDI?.purchaseOrder">
              <div class="label">PO #:</div>
              <div class="value">
                {{receiveEDI.purchaseOrder}}
              </div>
            </div>
            <div class="inventory-details" *ngIf="receiveEDI?.invoiceNumber">
              <div class="label">Invoice #:</div>
              <div class="value">
                {{receiveEDI.invoiceNumber}}
              </div>
            </div>
            <div class="inventory-details" *ngIf="receiveEDI?.csos">
              <div class="label">CSOS #</div>
              <div class="value">
                {{receiveEDI.csos}}
              </div>
            </div>
        </div>
        <div lass="flex">
          <div class="inventory-details" *ngIf="receiveEDI?.shippedDate">
            <div class="label">Shipped Date:</div>
            <div class="value">
              {{receiveEDI.shippedDate | date}}
            </div>
          </div>
          <div class="inventory-details">
            <div class="label">Contains:</div>
            <div class="value">
              {{receiveEDI?.orderLineItems?.length}} NDC{{receiveEDI?.orderLineItems?.length !== 1 ? 's' : ''}}
            </div>
          </div>
        </div>
      </div>
      <form class="inventory-details date-picker-and-location flex flex-row space-x-4" [formGroup]="form">
        <app-inventory-locations-dropdown *ngIf="inventoryLocationsEnabled$ | async"
            class="inventory-locations-dropdown"
            label="Location"
            [formControl]="form.controls.inventoryLocationId"
            #location
        ></app-inventory-locations-dropdown>
        <app-datepicker-input [tabInd]="0" 
          label="Transaction Date/Time"
          pickerType="both"
          formControlName="transactionDateDisplayValue"
          (dateTimeChange)="dateTimeChanged($event)"
          [dateMax]="now()"
          (inputTabKeyDown)="tabFromDatePicker()"
          (afterPickerClosed)="tabFromDatePicker()"
          calendarPosition="right"
          #transactionDatePicker>
        </app-datepicker-input>
      </form>
  </div>
  <div #buyerSupplier>
    <app-supplier-buyer-sale-details class="block pt-3" *ngIf="receiveEDI?.buyerDetails || receiveEDI?.supplierDetails"
      [supplier]="receiveEDI?.supplierDetails"
      [buyer]="receiveEDI?.buyerDetails"
      [readOnly]="true"
      [takeDefaultSupplier]="false"
      [pharmacyIsSupplier]="false"
      >
    </app-supplier-buyer-sale-details>
  </div>
  </div>
  <div #fileAttachmentWrapper [formGroup]="form">
    <app-file-attachment 
      [files]="orderFiles$ | async"
      [fileTypes]="fileTypes"
      [requiresSignature]="true"
      [csosControl]="form.get('csos')"
      (downloadFile)="downloadFile($event)"
      (saveFiles)="saveAttachmentsList($event)"
    >
    </app-file-attachment>
  </div>
 
  <div class="table-scroll-wrapper">
    <table class="table-primary inventory-history-table">
      <thead>
      <tr>
        <th class="text-left sort drug" scope="col">
          Drug
          <img [class.asc]="tableOptions.asc"
               class="sort-icon"
               src="assets/icons/icon-arrow-down.svg"
               alt="asc"
          />
        </th>
        <th class="text-right on-hand" scope="col">On-hand</th>
        <th class="text-right receiving" scope="col">Receiving</th>
        <th class="text-right new-total" scope="col">New Total</th>
        <th class="text-right controls" scope="col">
          <!-- Controls -->
        </th>
      </tr>
      </thead>
      <tbody [ngStyle]="{'--table-height': tableHeight}">
      <tr class="table-row" *ngFor="let rowData of receiveEDI?.orderLineItems; let i = index">
        <td class="text-left drug">
          <div class="heading">
            {{rowData.friendlyName}}
          </div>
          <div class="secondary">
            {{rowData.packageNdc}}
            <span *ngIf="rowData.isNew" class="label-new">New</span>
          </div>
        </td>
        <td class="text-right on-hand">
          {{rowData.onHand | number}}
        </td>
        <td class="text-right receiving">
          <ng-container *ngIf="editRow[i]">
            <app-input [textAlign]="'right'"
                       type="number"
                       [invalid]="+receivingValue[i] < 0"
                       (keyupEnter)="closeEditMode(i)"
                       [(ngModel)]="receivingValue[i]"
                       (keydownTab)="editValueInputTabKeyDownKeyUpHandler(i)"
                       id="receiving_{{i}}"
                       #appInput
            ></app-input>
          </ng-container>
          <ng-container *ngIf="!editRow[i]">
            <span (click)="openEditMode(i)">{{rowData.receiving | number}}</span>
          </ng-container>
        </td>
        <td class="text-right new-total">
          {{(+rowData.onHand + +rowData.receiving) | number}}
        </td>
        <td class="text-right control">
          <ng-container *ngIf="editRow[i]">
            <app-button customClasses="px-4"
                        [minWidth]="0"
                        styleClass="settings"
                        subStyle="blue"
                        text="Update"
                        class="update"
                        [disabled]="+receivingValue[i] < 0"
                        (clicked)="closeEditMode(i)"
                        #updateButton
            >
            </app-button>

            <app-button customClasses="px-4"
                        [minWidth]="0"
                        text="Cancel"
                        subStyle="white"
                        class="cancel"
                        (clicked)="closeEditMode(i, false)"
            >
            </app-button>
          </ng-container>
          <ng-container *ngIf="!editRow[i]">
            <app-button customClasses="px-4"
                        [minWidth]="0"
                        text="Edit"
                        subStyle="white"
                        class="edit"
                        (clicked)="openEditMode(i)"
            >
            </app-button>
          </ng-container>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <div class="inventory-controls-container">
    <div class="label">
      Receiving {{receiveEDI?.orderLineItems?.length}} NDC{{receiveEDI?.orderLineItems?.length !== 1 ? 's' : ''}}
    </div>

    <app-button
      text="Receive {{receiveEDI?.orderLineItems?.length}} Drug{{receiveEDI?.orderLineItems?.length !== 1 ? 's' : ''}}"
      customClasses="px-4"
      [minWidth]="0"
      class="receive"
      [disabled]="anyEditModeOpen() || !receiveEDI || form.invalid"
      (clicked)="openPinDialog()"
      (keydownTab)="tabbingStartOver()"
     
      #receiveButton
    >
    </app-button>
  </div>
</div>

<app-enter-pin-dialog [show]="showPinDialog"
                      (cancel)="closePinDialog()"
                      [focusPin]="focusPin"
                      (setPinHandler)="validateRequest($event)"
                      (handleResetPin)="openResetPinDialog()"
></app-enter-pin-dialog>

<app-reset-pin-dialog [show]="showResetPinDialog"
                      (cancel)="closeResetPinDialog()"
                      (afterUpdate)="afterPinUpdated($event)"
></app-reset-pin-dialog>
